import HtmlElement from '../../../Elements/HtmlElement';
import { Selectors } from '../Settings';
import {$body} from "../../../Constants";

const RangeInput = (() => {

	class RangeInput extends HtmlElement {

		onReady() {
			super.onReady();

			this.bindHandlers();
		}

		bindHandlers() {
			this.input = this._$element.find('input');
			this.value = this._$element.find(Selectors.RANGE_INPUT_VALUE);
			this.format = this.value.data('format');

			this.input.on('input', () => {
				this.updateValue();
			});
			this.updateValue();
		}

		updateValue() {
			let value = this.input.val();

			if(this.format && this[this.format]) {
				value = this[this.format](value);
			}

			this.value.html(value);
		}

		currency(value) {
			return parseFloat(value).toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		}
	}

	return RangeInput._getElements($body.find(Selectors.RANGE_INPUT), RangeInput);
})();

export default RangeInput;
